import { useParams } from 'react-router-dom'
import httpClient from '../shared/axios'
import { useEffect, useState } from 'react'
import { useLanguage } from '../context/languageContext';
import { FreeMode, Navigation, Thumbs } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/navigation';
import 'swiper/css/thumbs';
import { Swiper, SwiperSlide } from 'swiper/react';
import parse from "html-react-parser";

export default function News() {
  const { id } = useParams()
  const { language } = useLanguage();
  const [data, setData] = useState({})
  const [thumbsSwiper, setThumbsSwiper] = useState(null);

  useEffect(() => {
    const getSingleNews = async () => {
      const { data } = await httpClient.get(`/news/${id}/?lang=${language === 'oz' ? 'uz-cyrl' : language}`);
      setData(data)
    };

    getSingleNews();
  }, [id, language]);

  return (

    <div className="RegulationDocs py-5">
      <div className="container">
        <div className="row ">
          <div className="col-lg-5">
            <Swiper
              loop={false}
              spaceBetween={10}
              navigation={true}
              thumbs={{ swiper: thumbsSwiper }}
              modules={[FreeMode, Navigation, Thumbs]}
              className="mySwiper2"
            >
              {data?.images?.map((item) => (
                <SwiperSlide key={item.id}>
                  <img className='w-100' src={item.image} alt={data?.name} />
                </SwiperSlide>
              ))}
            </Swiper>
            <Swiper
              onSwiper={setThumbsSwiper}
              loop={false}
              spaceBetween={10}
              slidesPerView={4}
              freeMode={true}
              watchSlidesProgress={true}
              modules={[FreeMode, Navigation, Thumbs]}
              className="mySwiper mt-2"
            >
              {data?.images?.map((item) => (
                <SwiperSlide key={item.id}>
                  <img className='w-100' src={item.image} alt={data?.name} />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
          <div className="col-lg-6 offset-lg-1">
            <h1 className="mb-3">{data?.title}</h1>
            <p>{parse(data?.description || "")}</p>
          </div>
        </div>
      </div>
    </div>
  )
}
